import { render, staticRenderFns } from "./MailSetting.vue?vue&type=template&id=666aa07b&scoped=true&"
import script from "./MailSetting.vue?vue&type=script&lang=js&"
export * from "./MailSetting.vue?vue&type=script&lang=js&"
import style0 from "./MailSetting.vue?vue&type=style&index=0&id=666aa07b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666aa07b",
  null
  
)

export default component.exports